import React, { useState, useEffect } from 'react';
import { supabase } from '../db/engine';
import { useApp } from '../context/AppContext';
import SearchSelect from './SearchSelect';

// Buscador de cliente por nombre — ÚNICO selector de cliente del sistema.
// Escribe palabras sueltas en cualquier orden y sin acentos: "Ricardo Griffith"
// encuentra a "Ricardo Antonio Griffith Chávez" (ver src/utils/buscar.js).
//
// - value / onChange: cliente_id ('' = ninguno). El botón × limpia la selección.
// - options: pásalas si el padre ya mantiene la lista (p.ej. la refresca al crear
//   un cliente nuevo). Si se omite, el componente la carga solo y respeta el
//   alcance del agente restringido (solo sus clientes).
// - onCreate / createLabel: agrega la opción de crear un cliente al final.
// - width: ancho fijo opcional; sin él ocupa el ancho del contenedor.
export default function ClienteSelect({
  value, onChange, options, onCreate, createLabel,
  placeholder = 'Buscar cliente...', width,
}) {
  const { agenteScope, esAgenteRestringido } = useApp();
  const [propios, setPropios] = useState([]);
  const cargaPropia = !options;

  useEffect(() => {
    if (!cargaPropia) return;
    let q = supabase.from('clientes').select('id, nombre').order('nombre');
    if (esAgenteRestringido) q = q.in('id', agenteScope?.clienteIds?.length ? agenteScope.clienteIds : [-1]);
    q.then(({ data }) => setPropios(data || []));
  }, [cargaPropia, esAgenteRestringido, agenteScope]);

  return (
    <div style={width ? { width } : undefined}>
      <SearchSelect
        options={options || propios}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onCreate={onCreate}
        createLabel={createLabel}
      />
    </div>
  );
}
